"use client";
import { Button } from "@/components/ui/button";
import { Navigation } from "@/functions";
import { useRouter } from "next/navigation";

interface Props {
    title?: string;
    href?: string;
}
export const JoinButton = ({ title, href }: Props) => {
    const router = useRouter();
    return (
        // <Button
        //     onClick={() =>
        //         Navigation(router, href || "/admin/settings/billing")
        //     }
        //     className="relative z-10 h-10 rounded-lg bg-gradient-to-br from-primary to-secondary p-0.5 duration-300 group-hover:scale-110 "
        // >
        //     <span className="inset-1 z-50 block rounded-md bg-card px-2 py-2 font-semibold text-slate-100 duration-300 group-hover:bg-card group-hover:text-slate-50 group-active:bg-card">
        //         {title || "Join Pro"}
        //     </span>
        // </Button>
        <Button
            onClick={() =>
                Navigation(router, href || "/admin/settings/billing")
            }
            className="group relative inline-flex h-12 overflow-hidden rounded-lg bg-transparent p-[2px] hover:bg-transparent focus:outline-none focus:ring-2 focus:ring-slate-400 focus:ring-offset-2 focus:ring-offset-slate-50"
        >
            <span className="absolute inset-[-1000%] animate-[spin_2s_linear_infinite] bg-[conic-gradient(from_90deg_at_50%_50%,#CD514B_0%,#924bcd_50%,#CD514B_100%)]" />
            <span className="inline-flex h-full w-full cursor-pointer items-center justify-center rounded-lg bg-card/70 px-3 py-1 text-sm font-medium text-foreground backdrop-blur transition-all duration-300 group-hover:bg-card">
                {title || "Join Pro"}
            </span>
        </Button>
    );
};
